import { useEffect, useState } from "react";

const AutocompleteInput = ({
  masterList = [],
  getOptionLabel,
  getOptionValue,
  value,
  onValueChange,
  placeholder = "Select...",
  inputClassName = "",
  wrapperClassName = "",
  notFoundText = "Site not found",
  inputId,
  inputRef,
  disabled
}) => {
  const [searchText, setSearchText] = useState("");
  const [filteredOptions, setFilteredOptions] = useState(masterList || []);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [noMatch, setNoMatch] = useState(false);

  useEffect(() => {
    setFilteredOptions(masterList || []);

    if (value === null || value === undefined || value === "") {
      setSearchText("");
      setNoMatch(false);
      return;
    }

    if (!masterList || masterList.length === 0) return;

    const selected = masterList.find(
      (item) => getOptionValue && getOptionValue(item) === value
    );

    if (selected && getOptionLabel) {
      setSearchText(getOptionLabel(selected));
    }
  }, [masterList, value, getOptionLabel, getOptionValue]);

  const handleChange = (e) => {
    const inputValue = e.target.value;
    setSearchText(inputValue);

    if (!inputValue) {
      setFilteredOptions(masterList || []);
      setNoMatch(false);
      setShowSuggestions(false);
      if (onValueChange) onValueChange("", null);
      return;
    }

    const lower = inputValue.toLowerCase();

    const matches = (masterList || []).filter((item) => {
      if (!getOptionLabel) return false;
      const label = getOptionLabel(item) || "";
      return label.toLowerCase().includes(lower);
    });

    setFilteredOptions(matches);
    setShowSuggestions(true);
    setNoMatch(matches.length === 0);
  };

  const handleSelect = (option) => {
    const optionValue = getOptionValue ? getOptionValue(option) : null;
    if (onValueChange) onValueChange(optionValue, option);
    if (getOptionLabel) {
      setSearchText(getOptionLabel(option) || "");
    }
    setShowSuggestions(false);
    setNoMatch(false);
  };

  const handleFocus = () => {
    if ((masterList || []).length > 0) {
      setFilteredOptions(masterList || []);
      setShowSuggestions(true);
      setNoMatch(false);
    }
  };

  const handleBlur = () => {
    // allow click on suggestion before hiding
    setTimeout(() => setShowSuggestions(false), 150);
  };

  return (
    <div
      className={`position-relative w-100 ${wrapperClassName}`.trim()}
      style={{ minHeight: "38px" }}
    >
      <input
        type="text"
        id={inputId}
        className={inputClassName}
        placeholder={placeholder}
        value={searchText}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        ref={inputRef}
        autoComplete="off"
        disabled={disabled}
      />
      {showSuggestions && (
        <div
          className="bg-white border rounded mt-1 position-absolute w-100"
          style={{ zIndex: 10, maxHeight: "200px", overflowY: "auto" }}
        >
          {noMatch ? (
            <div className="px-3 py-2 text-muted">{notFoundText}</div>
          ) : (
            filteredOptions.map((option, index) => {
              const key = getOptionValue
                ? getOptionValue(option) || index
                : index;
              const label = getOptionLabel ? getOptionLabel(option) : "";
              return (
                <div
                  key={key}
                  className="px-3 py-2 site-suggestion-item"
                  style={{ cursor: "pointer" }}
                  onMouseDown={(e) => {
                    e.preventDefault();
                    handleSelect(option);
                  }}
                >
                  {label}
                </div>
              );
            })
          )}
        </div>
      )}
    </div>
  );
};

export default AutocompleteInput;
